<script setup lang="ts">
/**
 * Cookie Button - Laumeris
 * Bouton flottant discret pour rouvrir les paramètres cookies
 * Conforme CNIL : l'utilisateur doit pouvoir modifier ses choix à tout moment
 * Note: Ce bouton n'apparaît PAS dans le dashboard (zone authentifiée)
 */

import { computed } from 'vue'
import { useCookiesStore } from '@/stores/cookies'
import { useAuthStore } from '@/stores/auth'

const cookiesStore = useCookiesStore()
const authStore = useAuthStore()

// Ne pas afficher le bouton dans le dashboard (zone authentifiée)
const shouldShow = computed(() => {
  // Pas connecté et a consenti = afficher le bouton
  // Connecté = ne pas afficher (le lien est dans le footer du dashboard)
  return !authStore.isAuthenticated && 
         cookiesStore.hasConsented && 
         !cookiesStore.showBanner && 
         !cookiesStore.showSettings
})
</script>

<template>
  <!-- Bouton visible uniquement sur les pages publiques si l'utilisateur a déjà consenti -->
  <Transition
    enter-active-class="transition-all duration-300 ease-out"
    enter-from-class="opacity-0 scale-75"
    enter-to-class="opacity-100 scale-100"
    leave-active-class="transition-all duration-200 ease-in"
    leave-from-class="opacity-100 scale-100"
    leave-to-class="opacity-0 scale-75"
  >
    <button
      v-if="shouldShow"
      @click="cookiesStore.reopenBanner()"
      class="fixed bottom-4 left-4 z-50 group"
      title="Gérer les cookies"
      aria-label="Paramètres des cookies"
    >
      <div 
        class="w-10 h-10 rounded-full bg-white dark:bg-corporate-800 shadow-lg border border-corporate-200 dark:border-corporate-700 flex items-center justify-center transition-all hover:scale-110 hover:shadow-xl"
      >
        <svg 
          class="w-5 h-5 text-corporate-500 dark:text-corporate-400 group-hover:text-corporate-700 dark:group-hover:text-corporate-200 transition-colors" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            stroke-linecap="round" 
            stroke-linejoin="round" 
            stroke-width="1.5" 
            d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
          />
        </svg>
      </div>
      
      <!-- Tooltip -->
      <div class="absolute left-12 bottom-0 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        <div class="bg-corporate-900 text-white text-xs px-2 py-1 rounded whitespace-nowrap">
          Gérer les cookies
        </div>
      </div>
    </button>
  </Transition>
</template>

